"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/EyeShow.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EyeShow = function EyeShow(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 251.3 155.4"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Eye Icon"), _react2.default.createElement("g", {
    className: "eye-icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "eye",
    d: "M125.6 155.4c-40.8 0-71.9-16.4-86.8-26.3C14.5 113.2 0 93.9 0 77.7c0-18 20-37.8 38.8-50.5C53.9 17.1 85.3 0 125.6 0s71.8 17.1 86.9 27.2c18.7 12.6 38.8 32.5 38.8 50.5 0 8.3-3.9 17.4-11.7 27-6.8 8.4-16.1 16.7-27.1 23.9-15 10.1-46.3 26.8-86.9 26.8zm0-132c-34.7 0-61.9 14.6-75.1 23.3-20 13.2-29.1 26.9-29.3 31 0 3.9 7.2 17.3 28.5 31.3 13 8.6 40.2 22.9 75.8 22.9 35.4 0 62.7-14.7 75.8-23.4 20-13.1 28.7-26.7 28.7-30.7-.3-4.1-9.4-17.8-29.3-31-13.1-8.8-40.3-23.4-75.1-23.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "iris",
    d: "M125.6 8.7c-29.6 0-53.5 24-53.5 53.5s24 53.5 53.5 53.5 53.5-24 53.5-53.5-23.9-53.5-53.5-53.5zm-.3 32.6c-1.5.3-3.5.6-5.9 1.2-2.6.6-5.2 1.4-7.7 2.3-.7.2-1.3.5-2 .8-.7.3-1.3.6-1.9.9-1.3.7-2.5 1.4-3.7 2.2-1.2.8-2.3 1.7-3.3 2.7-1 1-1.9 2-2.8 3.1-.8 1.1-1.6 2.2-2.3 3.3-.4.5-.7 1.1-1 1.7-.3.6-.6 1.1-.9 1.6-.5 1.1-1.1 2.1-1.4 3s-.8 1.7-1 2.4c-.6 1.4-1 2.2-1 2.2s-.2-.7-.4-2.2c-.1-.9-.2-1.8-.2-2.8 0-1.2 0-2.4.2-3.6l.3-2.1c.1-.7.3-1.5.6-2.2.5-1.6 1.1-3.1 1.9-4.6.4-.8.9-1.6 1.4-2.3l.8-1.1c.3-.4.6-.7.9-1.1 1.2-1.4 2.6-2.7 4.2-3.8 1.5-1.1 3.2-2 4.9-2.7 1.6-.7 3.4-1.2 5.1-1.5 1.6-.3 3.2-.5 4.9-.6 1.4 0 2.9 0 4.3.2 2.1.2 4.2.7 6.2 1.5.8.3 1.5.6 2.2 1l-2.4.5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = EyeShow;